exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ant-list.cap-list-v2.ant-list-split .ant-list-item{border-bottom:1px solid #dfe2e7}\n", ""]);

// exports
